import * as React from "react";

class DescriptionComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const value = this.props.dataItem[this.props.field];
    const subText = value ? value.substr(0,200) : value;
    return (
      <td>
          {value && value.length > 200 ?
          <span>{subText} ....
          <a href="javacript:void(0)" title={value}>
            More
          </a>
          </span>
          : 
          <span>{value}</span>
        }
          
      </td>
    );
  }
}

export default DescriptionComponent;